// PayslipPdf.js
import React from "react";
import { Document, Page, Text, View } from "@react-pdf/renderer";
import { fonts, reportStyles } from "../report-style";
import ReportHeader from "../report-header";

fonts();

const PtaxPdf = ({
  ptaxDetails,
  restructuredPTaxData,
  ptaxOrgDetails,
  currentYear,
  nexttYear
}) => {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={reportStyles.page}>
        <View fixed>
          <ReportHeader organizationInfo={ptaxOrgDetails} />
        </View>
        <View wrap={true}>
          <View style={reportStyles.pdfSubHeader}>
            <View style={reportStyles.pdfSubHeaderBox}>
              <Text>
                {`P-TAX Report of ${currentYear} - ${nexttYear}`}
              </Text>
            </View>
            <View style={reportStyles.pdfSubHeaderBox}>
              <Text>
                EC CODE : {ptaxDetails?.ptax_ec_code}
              </Text>
            </View>
            <View style={reportStyles.pdfSubHeaderBox}>
              <Text>
                RC CODE : {ptaxDetails?.ptax_rc_code}
              </Text>
            </View>
          </View>
          {/* <View style={reportStyles.pdfHeaderTable}>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total employee:</Text>
                <Text>34</Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>EC Number:</Text>
                <Text>55</Text>
              </View>
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total salaried employee:</Text>
                <Text>11</Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>RC Number:</Text>
                <Text>66</Text>
              </View>
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total wages employee:</Text>
                <Text>00</Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Financial Year:</Text>
                <Text>77</Text>
              </View>
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Branch Name:</Text>
                <Text>99</Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total P-Tax Amount:</Text>
                <Text>77</Text>
              </View>
            </View>
            <View style={reportStyles.pdfHeaderTableBx}>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>State:</Text>
                <Text>456</Text>
              </View>
            </View>
          </View> */}
        </View>
        <View style={reportStyles.ReportMultitable}>
          {restructuredPTaxData?.map((report, index) => (
            <>
              <View style={reportStyles.ReportMultibox} key={index}>
                <Text style={reportStyles.ReportMultiboxheading}>P TAX RETURN OF {report?.month.toUpperCase()} {report?.year}</Text>
                <View style={reportStyles.ReportMultiboxsubheading}>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      { width: "25%", borderRight: "1px solid #ccc", textAlign: "left", fontSize: "6px" },
                    ]}
                  >
                    Tax Slab
                  </Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      { width: "25%", borderRight: "1px solid #ccc", textAlign: "left", fontSize: "6px" },
                    ]}
                  >
                    P-Tax Amount
                  </Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        borderRight: "1px solid #ccc", fontSize: "6px"
                      },
                    ]}
                  >No Of Employee</Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        textAlign: "right", fontSize: "6px"
                      },
                    ]}
                  >TOTAL AMT.</Text>
                </View>
                {report?.data?.map((item, index) => (
                  <View style={reportStyles.ReportMultiboxdetails} key={index}>
                    <Text
                      style={[
                        reportStyles.ReportHeaderCell,
                        { width: "25%",textAlign: "left", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc" },
                      ]}
                    >
                      {item?.taxSlab}
                    </Text>
                    <Text
                      style={[
                        reportStyles.ReportHeaderCell,
                        { width: "25%",textAlign: "left",  borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc" },
                      ]}
                    >
                      {item?.ptaxAmount}
                    </Text>
                    <Text
                      style={[
                        reportStyles.ReportHeaderCell,
                        {
                          width: "25%",
                          borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc"
                        },
                      ]}
                    >
                      {item?.noOfEmployee}
                    </Text>
                    <Text
                      style={[
                        reportStyles.ReportHeaderCell,
                        {
                          width: "25%",
                          textAlign: "right", borderBottom: "1px solid #ccc"
                        },
                      ]}
                    >
                      {item?.totalAmount}
                    </Text>
                  </View>
                ))}
                <View style={reportStyles.ReportMultiboxdetails}>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        borderRight: "1px solid #ccc",
                        borderBottom: "1px solid #ccc",
                        fontWeight: "bold",
                      },
                    ]}
                  >
                  </Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        borderRight: "1px solid #ccc",
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                      },
                    ]}
                  >
                    TOTAL
                  </Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        borderRight: "1px solid #ccc",
                        borderBottom: "1px solid #ccc",
                        fontWeight: "bold",
                      },
                    ]}
                  >
                    {report?.data?.reduce((sum, item) => sum + (item?.noOfEmployee || 0), 0)}
                  </Text>
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {
                        width: "25%",
                        textAlign: "right",
                        borderBottom: "1px solid #ccc",
                        fontWeight: "bold",
                      },
                    ]}
                  >
                    {report?.data?.reduce((sum, item) => sum + (item?.totalAmount || 0), 0)}
                  </Text>
                </View>
              </View>
            </>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default PtaxPdf;
